import React from 'react';
import OurCards from '../../../Components/Components.Rijon/OurCards';
import PageTitle from '../../PageTitle/PageTitle';
const Cards = () => {
    return (

        <div>
            {/* title */}

            <PageTitle title="Cards"></PageTitle>

            {/* end */}



            <OurCards />
        </div>
    );
};

export default Cards;